import { useState, useEffect } from 'react';
import { StepContent } from '../StepContent';
import { HdeOptionList } from '../HDEOptionList';
import type { StepContentProps } from '~/ui-rocco/multi-step-form';

/** Stage options matching Figma HDE design (node 180:4360) – always use these for consistent UX. */
const HDE_STAGE_OPTIONS = [
    {
        value: 'Just starting to scope',
        label: 'Just starting to scope',
        description: 'Gathering inspiration, not sure where to begin',
    },
    {
        value: 'Planning & researching',
        label: 'Planning & researching',
        description: 'Exploring options, comparing products and professionals',
    },
    {
        value: 'Working with a professional',
        label: 'Working with a professional',
        description: 'Already engaged an architect, designer, or builder',
    },
    {
        value: 'Under construction',
        label: 'Under construction',
        description: 'Build is underway, still making product decisions',
    },
];

interface ProjectStageData {
    projectStage: string | null;
}

export function ProjectStageStep({
    setIsValid,
    onDataChange,
    onNext,
    initialData,
}: StepContentProps) {
    const data = initialData as ProjectStageData | undefined;

    const [projectStage, setProjectStage] = useState<string | null>(
        data?.projectStage || null,
    );

    useEffect(() => {
        const isValid = projectStage !== null;
        setIsValid(isValid);
        onDataChange?.({ projectStage });
    }, [projectStage, setIsValid, onDataChange]);

    return (
        <div className="flex min-h-0 flex-1 flex-col">
            <StepContent>
                <HdeOptionList
                    label="WHERE ARE YOU IN THE JOURNEY?"
                    options={HDE_STAGE_OPTIONS}
                    mode="single"
                    value={projectStage}
                    onChange={setProjectStage}
                    appearance="button"
                    optionVariant="with-description"
                    onSelectAndAdvance={(value) => {
                        onDataChange?.({ projectStage: value });
                        onNext();
                    }}
                />
            </StepContent>
        </div>
    );
}
